import { ButtonProps, Button as MuiButton } from '@mui/material'
import { CSSProperties, cloneElement } from 'react'

function Button ( {
    className, variant, size, sx,
    children,
    ...rest
}: CustomButtonProps ) {
    const defaultSx: CSSProperties = {  height: '50px' }
    const props: CustomButtonProps = {
        ...rest,
        sx: { ...defaultSx, ...sx },
        className, variant, size
    }

    if ( !variant ) {
        props.className = className ? className + ` button-default` : `button-default`
    }

    return cloneElement( <MuiButton className={ props.className }/>, props, children )
}

export default Button

export interface CustomButtonProps extends ButtonProps {
    [ data: string ]: any
}